import React, { createContext } from 'react';
import { setBaseUrl, setAuthToken } from '../utils/api';

const ApiContext = createContext(null);

/**
 * Provides runtime API base URL + auth token from the parent app.
 * All package requests go through `utils/api` (axios) so the parent owns auth.
 */
export const ApiProvider = ({ children, apiUrl, authToken }) => {
  // Configure before descendants render. A child may request data from a
  // layout/effect hook on its first mount, before a parent useEffect runs.
  if (apiUrl) setBaseUrl(apiUrl);
  setAuthToken(authToken || null);

  return (
    <ApiContext.Provider value={{ apiUrl, authToken }}>
      {children}
    </ApiContext.Provider>
  );
};

export default ApiContext;
